// STATE
const state = { messages: [], isEnabled: true, fetchSettingWizardFlag: false }

// ACTIONS
const actions = {
  setMessages({ commit }, messages) {
    commit('setMessages', messages)
  },
  setSocketEnabledFlag({ commit }, isEnabled) {
    commit('setSocketEnabledFlag', isEnabled)
  },
  setFetchSettingWizardFlag({ commit }, isFetchData) {
    commit('setFetchSettingWizardFlag', isFetchData)
  }
}
// MUTATIONS
const mutations = {
  setMessages(state, messages) {
    state['messages'] = [...messages]
  },
  setSocketEnabledFlag(state, isEnabled) {
    state['isEnabled'] = isEnabled
  },
  setFetchSettingWizardFlag(state, isFetchData) {
    state['fetchSettingWizardFlag'] = isFetchData
  }
}
// GETTERS
const getters = {
  getMessages() {
    return state['messages']
  },
  isSocketEnabled() {
    return state['isEnabled']
  },
  isFetchSettingWizardFlag() {
    return state['fetchSettingWizardFlag']
  }
}
export const socket = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/_store/socket.module.js